import * as React from "react"
import { Box } from "@mui/material"
import {useStockAssDetailsReportForm} from "../../@hooks";
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm } = useStockAssDetailsReportForm()

    return <Box componet="span" data-tour="assdetails-create-report">
        <ActionButton
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}
